import PageLayout from '@app-studio-web/ui/components/PageLayout'
import { ReactNode } from 'react'
import QuizProgressHeader from './QuizProgressHeader'

// Shared wrapper for every quiz step after the Flow landing page. Renders the
// persistent progress header (back button + progress bar + % + encouragement)
// on top of our existing light-themed PageLayout.
export default function QuizLayout({ children }: { children: ReactNode }) {
  return (
    <PageLayout>
      <QuizProgressHeader />
      {children}
    </PageLayout>
  )
}
